// pages/UserAdmin/crm/icons.js
//
// Mapa único de "papel semântico" → componente `react-icons/fi`. É a
// fonte de verdade dos ícones do CRM — em nenhum arquivo desta pasta
// deve aparecer emoji hard-coded.
//
// Motivação (set/26): o HTML de referência usava emojis (📌 📁 🏷 💬…),
// mas emoji renderiza diferente por OS, contamina o alinhamento
// vertical em rows de tabela e não segue o line-height. Ícones SVG
// resolvem os três.
//
// Chaves em PascalCase (`Icon.Close`, não `Icon.close`) porque o
// eslint-plugin-react exige que qualquer componente JSX referenciado
// como `<X.y />` tenha `y` em PascalCase ou SCREAMING_SNAKE_CASE.
// Aliases em camelCase existiam antes; foram removidos pra não
// duplicar API.
//
// Se aparecer necessidade de ícone novo, adicione aqui — nunca
// importe direto de `react-icons/fi` num componente de tela.

import {
  // navegação / crumbs
  FiChevronDown, FiChevronRight, FiChevronLeft, FiChevronUp,
  FiArrowUp, FiArrowDown,
  // ações
  FiPlus, FiEdit2, FiEdit3, FiX, FiCheck, FiTrash2, FiRefreshCw,
  FiSearch, FiFilter, FiMoreHorizontal,
  // domínio CRM
  FiStar,          // pin/favorito (substitui 📌 do HTML)
  FiFolder,        // pasta
  FiTag,           // etiqueta
  FiMessageCircle, // abrir conversa
  FiClock,         // silêncio prolongado / lembrete
  FiUser,          // contato / agente
  FiUsers,         // equipe
  FiPhone,         // telefone
  FiCalendar,      // reunião / agendamento
  FiAlertCircle,   // status pendente / alerta
  FiCheckCircle,   // status confirmado
  FiXCircle,       // no-show
  // uploads / io
  FiUpload, FiDownload,
  // externo
  FiExternalLink,
  FiSend,          // disparo de template em lote
} from 'react-icons/fi';

export const Icon = {
  // Navegação
  ChevronDown: FiChevronDown,
  ChevronUp:   FiChevronUp,
  ChevronLeft: FiChevronLeft,
  ChevronRight: FiChevronRight,
  ArrowUp:     FiArrowUp,
  ArrowDown:   FiArrowDown,

  // Ações genéricas
  Plus:  FiPlus,
  Edit:  FiEdit2,
  EditPen: FiEdit3,
  Close: FiX,
  Check: FiCheck,
  Trash: FiTrash2,
  Refresh: FiRefreshCw,
  Search: FiSearch,
  Filter: FiFilter,
  More:  FiMoreHorizontal,

  // Domínio CRM
  Pin:   FiStar,          // 📌
  Folder: FiFolder,       // 📁
  Tag:   FiTag,           // 🏷
  Chat:  FiMessageCircle, // 💬
  Clock: FiClock,         // ⏰ / ⏱
  User:  FiUser,
  Users: FiUsers,
  Phone: FiPhone,
  Calendar: FiCalendar,   // 📅
  Alert: FiAlertCircle,
  Confirmed: FiCheckCircle,
  NoShow: FiXCircle,
  Send: FiSend,

  // IO
  Upload:   FiUpload,
  Download: FiDownload,
  External: FiExternalLink,
};
